import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';
import * as messageAlert from '../../../actions/messageAlertAction';
import { GROUPS } from '../../../const';
import * as groupsApi from '../../../services/api/groupApi';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class RemoveGroupReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.closeModal = this.closeModal.bind(this);
    this.handleRemoveGroupClassroom = this.handleRemoveGroupClassroom.bind(this);
  }

  static propTypes = {
    group: PropTypes.object,
    classroomGroupActions: PropTypes.object,
    messageAlert: PropTypes.object,
    colors: PropTypes.object
  };

  closeModal() {
    const { classroomGroupActions } = this.props;
    classroomGroupActions.setGroupToRemove();
  }

  handleRemoveGroupClassroom() {
    const { classroomGroupActions, group, messageAlert } = this.props;
    this.closeModal();
    classroomGroupActions.removeGroup(group.id).then(() => {
      classroomGroupActions.setSelectedGroup(GROUPS.EVERYONE);
      messageAlert.success(I18n.t('removeGroupPopup.deleteSuccess', { groupName: groupsApi.getGroupName(group) }));
    });
  }

  render() {
    const { group } = this.props;

    return (
      <Modal
        id="remove-group"
        title={I18n.t('removeGroupPopup.deleteGroup')}
        active={!!group}
        onClickOutside={this.closeModal}
        children={
          <Paragraph className="text-grey-700">
            {I18n.t('removeGroupPopup.removeGroupDisclaimer')} {I18n.t('common.uSure')}
          </Paragraph>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.handleRemoveGroupClassroom} primary label={I18n.t('common.delete')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    group: state.group.groupToRemove,
    i18n: state.i18n,
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveGroupReveal);
